export default __webpack_public_path__ + "static/59-b1b6d8ddc64531f96ad15ef13cf74704.png";